<template>
  <el-row :gutter="24">
    <el-col :span="9"><div class="grid-content bg-purple mast-center">  <img v-if="mast" :src="mast" > </div></el-col>
    <el-col :span="15"><div class="grid-content bg-purple"><p>岳西友辰信息科技有限公司是移动互联网解决方案领域研究和开发的科技企业。前身为岳西立信计算机软件工作室。工作室成立时间为2011年3月29日。在教育科技、金融服务、共享科技、电子商务等方向上有着深厚的底蕴和丰富的经验。</p>
      <p>本公司将充分发挥自身优势。秉承“科技领先，服务市场诚信待人、追求完美的宗旨和“产品就是人品”的企业理念，不断进行技术创新、服务创新和管理方式创新来继续研发出更多满足未来发展需要的软件产品，推动我国的信息化事业的发展。</p>
    </div></el-col>
  </el-row>

</template>

<script>
import Mast from '@/assets/mast.png'
export default {
  name: 'Instroduction',
  data () {
    return {
      mast: Mast,
      urls: [
        'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg'
      ]
    }
  }
}
</script>

<style scoped>
  .grid-content {
    border-radius: 15px !important;
    font-size: 1.8em;
    line-height: 2em;
  }
  .bg-purple {

  }
  p{text-indent:2em;
    text-align: justify;
  width: 25em;}
  .mast-center
  {
    text-align: right;
  }
  .mast-center img{
    max-width: 400px;
  }
</style>
